import { useTranslation } from 'react-i18next';
import { MetricasFinanceiras, formatarValorEUR } from '@/hooks/useDashboardFinanceiro';
import { MetricCard } from './CardsResumo';

interface CardsResumoFinanceiroProps {
  dados: MetricasFinanceiras;
}

export function CardsResumoFinanceiro({ dados }: CardsResumoFinanceiroProps) {
  const { t } = useTranslation();
  const taxaConclusao =
    dados.totalOS > 0 ? Math.round((dados.osConcluidas / dados.totalOS) * 100) : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <MetricCard
        titulo={t('dashboard.cards.totalRevenue')}
        valor={formatarValorEUR(dados.faturamentoTotal)}
        subtitulo={t('dashboard.cards.totalRevenueSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.averageTicket')}
        valor={formatarValorEUR(dados.ticketMedio)}
        subtitulo={t('dashboard.cards.averageTicketSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.totalOS')}
        valor={dados.totalOS}
        subtitulo={t('dashboard.cards.totalOSSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.completedOS')}
        valor={dados.osConcluidas}
        subtitulo={t('dashboard.cards.completedOSSubtitle', { percentage: taxaConclusao })}
      />
    </div>
  );
}
